document.addEventListener("DOMContentLoaded", function () {
	const submenuButtons = document.querySelectorAll(".submenu-btn");
	const dropdowns = document.querySelectorAll(".dropdown-content");
	const mainNav = document.querySelector(".main-nav");
	const submenuBar = document.querySelector(".submenu-bar");
	const dropdownContainers = document.querySelectorAll(".dropdown-container");
	const navButtons = document.querySelectorAll(".nav-btn[data-tab]");
	const navWrapper = document.querySelector(".nav-wrapper");

	// Track if tab has been opened before
	const tabOpenedBefore = {};

	const shopButton = document.querySelector('.nav-btn[data-tab="shop"]');
	if (shopButton && submenuButtons.length > 0) {
		// shopButton.classList.add('active');
		// submenuBar.classList.add('active');
	}

	navButtons.forEach(function (btn) {
		const handleActivation = function (e) {
			e.stopPropagation();
			const tabHandle = this.getAttribute("data-tab");

			navButtons.forEach(function (b) {
				b.classList.remove("active");
			});

			this.classList.add("active");

			// First remove active from all dropdowns
			submenuButtons.forEach(function (b) {
				b.classList.remove("active");
			});
			dropdowns.forEach(function (d) {
				d.classList.remove("active");
			});

			// Find the main dropdown for this tab
			const mainDropdown = document.querySelector('.main-dropdown[data-tab="' + tabHandle + '"]');

			if (mainDropdown) {
				// Activate submenu bar first
				setTimeout(function () {
					submenuBar.classList.add("active");
					// Hide all main-dropdowns first
					document.querySelectorAll(".main-dropdown").forEach(function (dropdown) {
						dropdown.style.display = "none";
					});

					// Show the current tab's dropdown
					mainDropdown.style.display = "block";
				}, 350);
				// Handle discover-items if this is the discover tab
				const discoverItems = mainDropdown.querySelectorAll('.discover-item');
				if (discoverItems.length > 0) {
					discoverItems.forEach(function (item, index) {
						item.setAttribute('tabindex', '0');
						// Handle Tab on last discover item
						// Only add listener if not already added
						if (index === discoverItems.length - 1 && !item.hasAttribute('data-tab-handler')) {
							item.setAttribute('data-tab-handler', 'true');
							item.addEventListener('keydown', function (e) {
								if (e.key === 'Tab' && !e.shiftKey) {
									e.preventDefault();
									// Move to next nav button or store locator
									const allNavButtons = Array.from(document.querySelectorAll('.nav-btn'));
									const currentNavBtn = document.querySelector('.nav-btn.active');
									if (currentNavBtn) {
										const navIndex = allNavButtons.indexOf(currentNavBtn);
										if (navIndex >= 0 && navIndex < allNavButtons.length - 1) {
											allNavButtons[navIndex + 1].focus();
										} else {
											const storeLocator = document.querySelector('.store-locator-btn');
											if (storeLocator) {
												storeLocator.focus();
											}
										}
									}
								}
							});
						}
					});
				}

				// Check if this is the first time opening this tab
				const isFirstTime = !tabOpenedBefore[tabHandle];
				if (isFirstTime) {
					tabOpenedBefore[tabHandle] = true;
				}

				// Wait for submenu-bar to finish opening (250ms) before activating content
				setTimeout(function () {
					// If shop tab is active, activate the submenu button with handle 'all' and its dropdown
					if (tabHandle === "shop") {
						const firstSubmenuBtn = document.querySelector(
							'.submenu-btn[data-submenu="most-loved"]'
						);
						if (firstSubmenuBtn) {
							firstSubmenuBtn.classList.add("active");

							// Find the sibling dropdown container
							const dropdownContainer = firstSubmenuBtn.nextElementSibling;
							if (dropdownContainer && dropdownContainer.classList.contains("dropdown-container")) {
								const allDropdown = dropdownContainer.querySelector('.dropdown-content[data-submenu="most-loved"]');

								if (allDropdown) {
									if (isFirstTime) {

										// First time: Animate with JavaScript in cascade
										allDropdown.classList.add("active");

										// Animate shop-all-box first
										const shopAllBox = allDropdown.querySelector('.shop-all-box');
										if (shopAllBox) {
											shopAllBox.style.transitionDelay = '0s';
										}

										// Then animate category items one by one
										const categoryItems = allDropdown.querySelectorAll('.category-item');
										categoryItems.forEach(function (item, index) {
											item.addEventListener('mouseenter', function () {
												const img = item.querySelector('.category-image img');
												if (img) {
													img.style.transform = 'scale(1.05)';
												}
											});
											item.addEventListener('mouseleave', function () {
												const img = item.querySelector('.category-image img');
												if (img) {
													img.style.transform = 'scale(1)';
												}
											});
										});

									} else {
										// Subsequent times: CSS handles everything
										allDropdown.classList.add("active");
									}
								}
							}
						}
					}
				}, 200);
			} else {
				submenuBar.classList.remove("active");
			}
		};

		btn.addEventListener("click", handleActivation);
		btn.addEventListener("focus", handleActivation);

		// Handle Tab key to navigate into submenu bar
		btn.addEventListener("keydown", function (e) {
			// If Tab key (not Shift+Tab) and this nav button is active
			if (e.key === "Tab" && !e.shiftKey && this.classList.contains("active")) {
				const tabHandle = this.getAttribute("data-tab");
				const mainDropdown = document.querySelector('.main-dropdown[data-tab="' + tabHandle + '"]');

				if (mainDropdown && mainDropdown.style.display === "block") {
					// Check if this dropdown has submenu buttons (like Shop)
					const firstSubmenuBtn = mainDropdown.querySelector('.submenu-btn');
					if (firstSubmenuBtn) {
						e.preventDefault();
						firstSubmenuBtn.focus();
					} else {
						// No submenu buttons, check for discover-items (like Discover tab)
						const firstDiscoverItem = mainDropdown.querySelector('.discover-item');
						if (firstDiscoverItem) {
							e.preventDefault();
							firstDiscoverItem.focus();
						}
					}
				}
			}
		});
	});

	submenuButtons.forEach((button) => {
		// Check if button has children (dropdown content)
		const dropdownContainer = button.nextElementSibling;
		const hasChildren = dropdownContainer &&
			dropdownContainer.classList.contains("dropdown-container") &&
			dropdownContainer.querySelector('.dropdown-content');

		// If no children and has href, let it behave as normal link
		if (!hasChildren && button.hasAttribute('data-parent-url')) {
			const href = button.getAttribute('data-parent-url');
			console.log('Found href for button without children:', href);

			// Add click handler to desktop button to navigate to the href
			button.addEventListener('click', function () {
				if (href) {
					window.location.href = href;
				}
			});

			// Find corresponding mobile button and add touch handler
			const submenu = button.getAttribute("data-submenu");
			const mobileButton = document.querySelector('.mobile-submenu-btn[data-submenu="' + submenu + '"]');
			if (mobileButton) {
				console.log('Found mobile button for:', submenu);
				mobileButton.addEventListener('touchstart', function (e) {
					e.preventDefault();
					e.stopPropagation();
					if (href) {
						window.location.href = href;
					}
				});
				mobileButton.addEventListener('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					if (href) {
						window.location.href = href;
					}
				});
			}
			return; // Skip adding custom event handlers
		}



		const handleSubmenuActivation = function () {
			var that = this;
			const submenu = this.getAttribute("data-submenu");

			// Remove active class from all submenu buttons
			submenuButtons.forEach((btn) => {
				btn.classList.remove("active");
			});

			// Add active class to current button
			this.classList.add("active");

			// Find the sibling dropdown container
			const dropdownContainer = that.nextElementSibling;
			if (dropdownContainer && dropdownContainer.classList.contains("dropdown-container")) {
				// Remove active from all dropdowns first to reset animations
				const allDropdowns = document.querySelectorAll(".dropdown-content");
				allDropdowns.forEach((dropdown) => {
					dropdown.classList.remove("active");
				});

				const dropdown = dropdownContainer.querySelector('.dropdown-content[data-submenu="' + submenu + '"]');
				if (dropdown) {
					dropdown.classList.add("active");

					// Ensure all links in the dropdown are focusable
					const links = dropdown.querySelectorAll('a');
					console.log('Found ' + links.length + ' links in dropdown');
					links.forEach(function (link, index) {
						link.setAttribute('tabindex', '0');
						console.log('Set tabindex on:', link.href);

						// Handle Tab on the last link to move to next submenu button or nav button
						// Only add listener if not already added
						if (index === links.length - 1 && !link.hasAttribute('data-tab-handler')) {
							link.setAttribute('data-tab-handler', 'true');
							link.addEventListener('keydown', function (e) {
								if (e.key === 'Tab' && !e.shiftKey) {
									e.preventDefault();
									// Find the current submenu button's parent
									const currentSubmenuBtn = that;
									// Get all submenu buttons in this main dropdown
									const firstSubmenuBtns = Array.from(currentSubmenuBtn.parentElement.parentElement.querySelectorAll('.submenu-btn'));
									const currentIndex = firstSubmenuBtns.indexOf(currentSubmenuBtn);

									// If there's a next submenu button, focus it
									if (currentIndex >= 0 && currentIndex < firstSubmenuBtns.length - 1) {
										firstSubmenuBtns[currentIndex + 1].focus();
									} else {
										// This was the last submenu button, move to next nav button
										const currentNavBtn = document.querySelector('.nav-btn.active');
										if (currentNavBtn) {
											const allNavButtons = Array.from(document.querySelectorAll('.nav-btn'));
											const navIndex = allNavButtons.indexOf(currentNavBtn);
											if (navIndex >= 0 && navIndex < allNavButtons.length - 1) {
												allNavButtons[navIndex + 1].focus();
											} else {
												// Last nav button, move to store locator or next focusable element
												const storeLocator = document.querySelector('.store-locator-btn');
												if (storeLocator) {
													storeLocator.focus();
												}
											}
										}
									}
								}
							});
						}
					});

					// Reset inline styles so CSS takes over (for hover transitions)
					const categoryItems = dropdown.querySelectorAll('.category-item');
					categoryItems.forEach(function (item) {
						item.style.transitionDelay = '';
						const img = item.querySelector('.category-image img');
						if (img) {
							img.style.transitionDelay = '';
						}
					});

					const shopAllBox = dropdown.querySelector('.shop-all-box');
					if (shopAllBox) {
						shopAllBox.style.transitionDelay = '';
					}
				}
			}
		};

		button.addEventListener("mouseover", handleSubmenuActivation);
		button.addEventListener("focus", handleSubmenuActivation);

		// Handle Tab key to navigate into dropdown
		button.addEventListener("keydown", function (e) {
			// If Tab key (not Shift+Tab) and button is active with dropdown open
			if (e.key === "Tab" && !e.shiftKey && this.classList.contains("active")) {
				const dropdownContainer = this.nextElementSibling;
				if (dropdownContainer && dropdownContainer.classList.contains("dropdown-container")) {
					const dropdown = dropdownContainer.querySelector('.dropdown-content.active');
					if (dropdown) {
						const firstLink = dropdown.querySelector('a');
						if (firstLink) {
							e.preventDefault();
							firstLink.focus();
						}
					}
				}
			}
		});
	});
	dropdownContainers.forEach((container) => {
		// Keep button active when hovering dropdown container
		container.addEventListener("mouseenter", function () {
			// Find the previous sibling button
			const button = this.previousElementSibling;
			if (button && button.classList.contains("submenu-btn")) {
				button.classList.add("active");
			}
		});

		container.addEventListener("mouseleave", function () {
			document
				.querySelectorAll(".dropdown-content")
				.forEach(function (dropdown) {
					dropdown.classList.remove("active");
				});
			submenuButtons.forEach(function (btn) {
				btn.classList.remove("active");
			});
		});
	});
	//   submenuBar.addEventListener("mouseleave", function () {
	//     dropdowns.forEach((dropdown) => {
	//       dropdown.classList.remove("active");
	//     });
	//     submenuButtons.forEach((button) => {
	//       button.classList.remove("active");
	//     });
	//   });

	// Deactivate everything when mouse leaves the nav-wrapper
	let deactivateTimer;
	if (navWrapper) {
		const deactivateAll = function () {
			navButtons.forEach(function (btn) {
				btn.classList.remove("active");
			});
			document.querySelectorAll(".main-dropdown").forEach(function (dropdown) {
				dropdown.classList.remove("active");
			});
			submenuButtons.forEach(function (btn) {
				btn.classList.remove("active");
			});
			dropdowns.forEach(function (dropdown) {
				dropdown.classList.remove("active");
			});
			submenuBar.classList.remove("active");
		};

		navWrapper.addEventListener("mouseleave", deactivateAll);

		// Deactivate when focus leaves both nav-wrapper AND submenu-bar (keyboard navigation)
		navWrapper.addEventListener("focusout", function () {
			// Use setTimeout to check if focus has moved outside the navigation area
			// This allows the browser to update document.activeElement properly
			clearTimeout(deactivateTimer);
			deactivateTimer = setTimeout(function () {
				// Check if the currently focused element is outside BOTH nav-wrapper and submenu-bar
				const activeElement = document.activeElement;
				if (!navWrapper.contains(activeElement) &&
					(!submenuBar || !submenuBar.contains(activeElement))) {
					deactivateAll();
				}
			}, 100);
		});

		// Also listen to focusout on submenu-bar
		if (submenuBar) {
			submenuBar.addEventListener("focusout", function () {
				clearTimeout(deactivateTimer);
				deactivateTimer = setTimeout(function () {
					const activeElement = document.activeElement;
					if (!navWrapper.contains(activeElement) &&
						!submenuBar.contains(activeElement)) {
						deactivateAll();
					}
				}, 100);
			});

			submenuBar.addEventListener("focusin", function () {
				clearTimeout(deactivateTimer);
			});
		}

		// Cancel deactivation when focus returns to nav-wrapper
		navWrapper.addEventListener("focusin", function () {
			clearTimeout(deactivateTimer);
		});
	}

	// Deactivate nav buttons when store locator button gets focus
	const storeLocatorBtn = document.querySelector('.store-locator-btn');
	if (storeLocatorBtn && navButtons) {
		storeLocatorBtn.addEventListener('focus', function () {
			navButtons.forEach(function (btn) {
				btn.classList.remove("active");
			});
			document.querySelectorAll(".main-dropdown").forEach(function (dropdown) {
				dropdown.classList.remove("active");
			});
			submenuButtons.forEach(function (btn) {
				btn.classList.remove("active");
			});
			dropdowns.forEach(function (dropdown) {
				dropdown.classList.remove("active");
			});
			submenuBar.classList.remove("active");
		});
	}

	// Mobile navigation
	function initMobileNav() {
		const mobileMenuToggle = document.getElementById("mobileMenuToggle");
		const mobileMenu = document.getElementById("mobileMenu");

		if (!mobileMenuToggle || !mobileMenu) return;

		mobileMenuToggle.addEventListener("click", function () {
			const isOpen = mobileMenu.classList.contains("active");

			const menuIcon = this.querySelector(".menu-icon");
			const closeIcon = this.querySelector(".close-icon");

			if (isOpen) {
				mobileMenu.classList.remove("active");
				if (menuIcon) menuIcon.style.display = "block";
				if (closeIcon) closeIcon.style.display = "none";
				document.body.style.overflow = "";

				// Hide after animation completes
				setTimeout(function () {
					if (!mobileMenu.classList.contains("active")) {
						mobileMenu.style.display = "none";
					}
				}, 400);
			} else {
				mobileMenu.style.display = "block";
				// Force reflow to trigger transition
				mobileMenu.offsetHeight;
				mobileMenu.classList.add("active");
				if (menuIcon) menuIcon.style.display = "none";
				if (closeIcon) closeIcon.style.display = "block";
				document.body.style.overflow = "hidden";
			}
		});

		document.querySelectorAll(".mobile-section-btn").forEach(function (btn) {
			btn.addEventListener("click", function () {
				console.log("click mobile-section-btn");
				const section = this.getAttribute("data-section");
				const content = document.querySelector(
					'.mobile-content[data-content="' + section + '"]'
				);
				const toggleIcon = this.querySelector(".toggle-icon");

				if (content) {
					const isOpen = content.classList.contains("active");

					// Close all content sections
					document.querySelectorAll(".mobile-content").forEach(function (c) {
						c.classList.remove("active");
						setTimeout(function () {
							if (!c.classList.contains("active")) {
								c.style.display = "none";
							}
						}, 400);
					});

					// Remove active class from all section buttons
					document.querySelectorAll(".mobile-section-btn").forEach(function (b) {
						b.classList.remove("active");
					});

					// Reset all toggle icons to plus (collapsed state)
					document.querySelectorAll(".toggle-icon").forEach(function (icon) {
						icon.innerHTML =
							`<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="#262018"/>
<path d="M8.60022 12.7023L13 12.7023M17.3998 12.7023L13 12.7023M13 12.7023L13 8.30249M13 12.7023L13 17.102" stroke="#262018" stroke-linecap="round"/>
</svg>`;
					});

					// If we're opening a section (it was closed), change this button's icon to minus and add active class
					if (!isOpen) {
						this.classList.add("active");

						if (toggleIcon) {
							toggleIcon.innerHTML =
								`<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.50281 12.7045L12.9026 12.7045L17.3024 12.7045" stroke="#262018" stroke-linecap="round" class="minus"/>
</svg>`;
						}

						content.style.display = "block";
						// Force reflow to trigger transition
						content.offsetHeight;
						content.classList.add("active");
					}
				}
			});
		});

		// Toggle mobile submenu dropdowns
		document
			.querySelectorAll(".mobile-submenu-btn[data-submenu]")
			.forEach(function (btn) {
				btn.addEventListener("click", function () {
					const submenu = this.getAttribute("data-submenu");
					const dropdown = document.querySelector(
						'.mobile-dropdown[data-submenu="' + submenu + '"]'
					);
					const arrow = this.querySelector(".arrow-icon");

					if (dropdown) {
						const isOpen = dropdown.classList.contains("active");

						// Close all other dropdowns
						document.querySelectorAll(".mobile-dropdown").forEach(function (d) {
							d.classList.remove("active");
							setTimeout(function () {
								if (!d.classList.contains("active")) {
									d.style.display = "none";
								}
							}, 400);
						});
						document
							.querySelectorAll(".mobile-submenu-btn .arrow-icon")
							.forEach(function (a) {
								a.style.transform = "";
							});

						// Toggle this dropdown
						if (!isOpen) {
							dropdown.style.display = "flex";
							// Force reflow to trigger transition
							dropdown.offsetHeight;
							dropdown.classList.add("active");
							if (arrow) arrow.style.transform = "rotate(180deg)";
						}
					}
				});
			});

		// Toggle mobile dropdowns
		document
			.querySelectorAll(".mobile-dropdown-btn[data-dropdown]")
			.forEach(function (btn) {
				btn.addEventListener("click", function () {
					const dropdown = this.getAttribute("data-dropdown");
					const content = document.querySelector(
						'[data-dropdown-content="' + dropdown + '"]'
					);
					const arrow = this.querySelector(".arrow-icon");

					if (content) {
						const isOpen = content.style.display === "block";

						document
							.querySelectorAll("[data-dropdown-content]")
							.forEach(function (c) {
								c.style.display = "none";
							});
						document.querySelectorAll(".arrow-icon").forEach(function (a) {
							a.style.transform = "";
						});

						if (!isOpen) {
							content.style.display = "block";
							if (arrow) arrow.style.transform = "rotate(180deg)";
						}
					}
				});
			});
	}
	initMobileNav();

	function addButtonsEevents() {
		const forms = document.querySelectorAll(
			'[data-type="add-to-cart-form"].costum-buy-buttons-card__form'
		);

		forms.forEach((form) => {
			const quantityInputs = form.querySelectorAll(
				".custom-product-card__variant input"
			);
			quantityInputs.forEach((input) => {
				input.addEventListener("change", (event) => {
					let pack = event.target.dataset.packName;
					let varianTitle = event.target.dataset.variantTile;
					let quantity = event.target.dataset.quantity;
					let price = event.target.dataset.price;

					// Remover clase active de todos los botones
					quantityInputs.forEach((btn) => {
						btn.checked = false;
					});

					event.currentTarget.checked = true;

					let labelPrice = form.querySelector(".-price");
					let propSizeInput = form.querySelector(".custom-prop-size");
					let propCaseInput = form.querySelector(".custom-prop-case");
					let propPriceInput = form.querySelector(".custom-prop-price");
					let propQuantityInput = form.querySelector(".custom-prop-quantity");

					propSizeInput.value = pack + " " + varianTitle;
					let is_Pack = pack == "6-pack" ? false : true; // false active the inputs for six pack
					labelPrice.textContent = price;

					propCaseInput.disabled = is_Pack;
					propPriceInput.disabled = is_Pack;
					propQuantityInput.disabled = is_Pack;
					propQuantityInput.value = quantity;
				});
			});
		});
	}

	const miDetails = document.querySelector(".header__search details");

	if (miDetails) {
		miDetails.addEventListener("toggle", (event) => {
			if (miDetails.open) {
				const resultsContainer = document.querySelector(
					".predictive-search.predictive-search--header"
				);

				if (!resultsContainer) return;

				const onResultsChanged = (mutationsList, observer) => {
					for (const mutation of mutationsList) {
						if (
							mutation.type === "childList" &&
							mutation.addedNodes.length > 0
						) {
							const searchItems =
								resultsContainer.querySelectorAll(".predictive-search__result-group");

							if (searchItems.length > 0) {
								addButtonsEevents();
							}
						}
					}
				};

				const observer = new MutationObserver(onResultsChanged);
				observer.observe(resultsContainer, {
					childList: true,
					subtree: true,
				});

				console.warn("Search watch activated...");

			} else {
				console.log("close.");
			}
		});
	}

	// Handle mobile search input to show/hide reset button
	const mobileSearchInput = document.querySelector("#Search-Mobile-Menu");
	if (mobileSearchInput) {
		const resetButton = mobileSearchInput.parentElement.querySelector(".reset__button");

		if (resetButton) {
			// Show/hide reset button based on input value
			mobileSearchInput.addEventListener("input", function () {
				if (this.value.trim() !== "") {
					resetButton.classList.remove("hidden");
				} else {
					resetButton.classList.add("hidden");
				}
			});

			// Clear input when reset button is clicked
			resetButton.addEventListener("click", function () {
				mobileSearchInput.value = "";
				this.classList.add("hidden");
				mobileSearchInput.focus();
			});
		}
	}
});
